export default __webpack_public_path__ + "static/media/esquadgroup_cinza.efa1955a.svg";